export default {
  state: {
    hasUnsavedChanges: false,
    popupConfirmResponse: true
  },

  mutations: {
    CHANGE_UNSAVED_CHANGES (state, flag) {
      state.hasUnsavedChanges = flag
    },
    SET_CONFIRM_RESPONSE (state, popupConfirmResponse) {
      state.popupConfirmResponse = popupConfirmResponse
    }
  },

  actions: {
    setHasUnsavedChanges: ({ commit }, flag) => {
      commit('CHANGE_UNSAVED_CHANGES', flag)
    },
    setConfirmResponse: ({ commit }, popupConfirmResponse) => {
      commit('SET_CONFIRM_RESPONSE', popupConfirmResponse)
    }
  },

  getters: {
    hasUnsavedChanges: state => state.hasUnsavedChanges,
    popupConfirmResponse: state => state.popupConfirmResponse
  }
}



// WEBPACK FOOTER //
// ./client/store/modules/exitingWithUnsavedChanges.js